import { DOCUMENT_FILE_TYPE } from '../enums/document-file-type.enum';

export enum DocumentType {
  TERM_SHEET = 'TERM_SHEET',
  FINAL_TERMS = 'FINAL_TERMS',
  KID = 'KID',
  OTHER = 'OTHER',
}

export const DOCUMENT_TYPE = [
  { id: DocumentType.TERM_SHEET, displayValue: DOCUMENT_FILE_TYPE.TERM_SHEET },
  { id: DocumentType.FINAL_TERMS, displayValue: DOCUMENT_FILE_TYPE.FINAL_TERMS },
  { id: DocumentType.KID, displayValue: DOCUMENT_FILE_TYPE.KID },
  { id: DocumentType.OTHER, displayValue: DOCUMENT_FILE_TYPE.OTHER },
];
